export const COMPLETION_LABELS: Record<string, string> = {
  completed: 'Completed',
  progressed: 'Progressed',
  handed_off: 'Handed off',
  stalled: 'Stalled',
  failed: 'Failed',
  no_task: 'No task',
};

export function formatRunDate(iso: string | null): string {
  if (!iso) return 'Unknown date';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return 'Unknown date';
  return d.toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
